var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.server !== null)?_c('div',{staticClass:"server"},[(_vm.server.toLowerCase() !== _vm.demoServer)?_c('span',{staticClass:"tag"},[_vm._v(" ⚠️️ "+_vm._s(_vm.server)+" ")]):_c('span',{staticClass:"tag demo"},[_vm._v(" "+_vm._s(_vm.server)+" ")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }